<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="false"></ReturnNavBar>
        </div>
        <div class="warehouse_detail_container mobile_container" v-loading="loading">
            <div class="warehouse_detail_wrap">
<!--                <div class="field_list flex_wrap">-->
<!--                    <div class="field_name">业务编号：</div>-->
<!--                    <div class="field_value"><span class="blue">XS-24090800011</span></div>-->
<!--                </div>-->
                <div class="product_data_detail">
                    <div class="field_item" v-for="item in formData.log_products">
                        <div class="field_list">
                            <div class="field_value" v-text="item.name"></div>
                        </div>
                        <div class="field_list flex_wrap">
                            <div class="field_name">入库仓库：</div>
                            <div class="field_value" v-if="item.stocks" v-text="item.stocks.name"></div>
                        </div>
                        <div class="field_list flex_wrap">
                            <div class="field_name">产品单价：</div>
                            <div class="field_value">{{item.cost_price}}（¥）</div>
                        </div>
                        <div class="field_list flex_wrap">
                            <div class="field_name">入库数量/产品编码：</div>
                            <div class="field_value">{{item.total_num}} <span @click="handleClickCodeDetail(item.details)" class="blue" v-if="item.code_num >0">编码明细</span></div>
                        </div>
                    </div>


                </div>
                <div class="field_list">
                    <div class="field_name">附件信息：</div>
                    <div class="field_value">
                        <div class="file_list" v-if="formData.files && formData.files.length>0">
                            <ul>
                                <li v-for="(file, file_idx) in formData.files" :key="file_idx">
                                    <p @click="handleClickPreview(file)" class="ellipsis" v-text="file.file_name"></p>
                                </li>
                            </ul>
                        </div>
                        <div v-else>--</div>
                    </div>
                </div>

                <div class="field_list">
                    <div class="field_name">备注信息：</div>
                    <div class="field_value">
                        <div v-text="formData.note || '--'"></div>
                    </div>
                </div>
            </div>
        </div>

        <CodeListDetail :codeListDetailPopupShow.sync="codeListDetailPopupShow" v-if="codeListDetailPopupShow" :codeList="codeList" />
    </div>
</template>

<script>
import { ImagePreview } from "vant";
import {stockLogDetail} from "@/api";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CodeListDetail from  "../component/code_list_detail"
export default {
    name: "inProductDetail",
    components: {ReturnNavBar,CodeListDetail},
    data() {
        return {
            loading:false,
            formData:{
                log_products:[],
                files:[],
                note:'',
            },
            id:'',
            codeListDetailPopupShow:false,
            codeList:[]
        };
    },
    created() {
        if(this.$route.query.id){
            this.id = this.$route.query.id
            this.getDetails()
        }
    },
    methods: {
        handleClickCodeDetail(code_list){
            this.codeList = code_list
            this.codeListDetailPopupShow = true
        },
        getDetails(){
            this.loading = true
            stockLogDetail({id:this.id}).then(res => {
                if(res.code == 200){
                    let { log_products, files, note} = res.data
                    this.formData = {
                        log_products,
                        files,
                        note,
                    }
                }
                this.loading = false
            })
        },
        //点击预览
        handleClickPreview(file) {
            if (file.file_type && file.file_type.indexOf("image") > -1) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file.file_type && file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //点击下载附件
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },

    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/inventory_management.scss";

</style>
